<template>
  <div id="home">
    <div class="content" v-loading="loading">
      <h1>Description</h1>
      <el-input
        type="textarea"
        :rows="5"
        placeholder="Description"
        v-model="info.description">
      </el-input>
      <h1>Image</h1>
      <div class="img" v-if="imageObj != null" :style="'background-image:url('+getImgS3(imageObj.newImage)+')'">
        <img v-if="imageObj.teethWhitening == 1" :style="'filter: brightness('+(imageObj.brightness/50)+') saturate('+(imageObj.saturate/50)+') contrast('+(imageObj.contrast/50)+');'" :src="getImgS3(imageObj.imageMask)"/>
      </div>
      <a @click="openCaseHistory" style="color:#3ea19d;cursor: pointer;"><i class="el-icon-picture"></i> Search</a>
      <div class="btn">
        <el-button type="primary" @click="save_model" icon="el-icon-check" size="small" style="background-color: #034844;border-color:#034844;padding:10px 20px;">Submit</el-button>
      </div>
      <case-history-list ref="listForm" @ok="selectImage"></case-history-list>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction, postAction } from '@/network/manage';
  import CaseHistoryList from './feedback/CaseHistoryList'

  export default {
    name: 'Feedback',
    components: {
      CaseHistoryList
    },
    data() {
      return {
        info:{},
        imageObj:null,
        loading:false
      }
    },
    computed: {

    },
    created(){

    },
    methods:{
      openCaseHistory(){
        this.$refs.listForm.init()
      },
      save_model(){
        if(!this.info.description){
          this.$message.error('Description is required')
        }else if(this.imageObj == null){
          this.$message.error('Please select an image')
        }else{
          const params = {
            caseHistoryId:this.imageObj.id,
            description:this.info.description
          }
          this.loading = true
          postAction('/admin/feedback/add',params).then((res) => {
            if(res.success){
              this.$message.success('Feedback success!')
              this.info = {}
              this.imageObj = null
            }else{
              this.$message.error(res.message)
            }
          }).catch((err) => {
            this.$message.error(err.message)
          }).finally((res) => {
            this.loading = false
          });
        }
      },
      getImgS3(key) {
        return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
      },
      selectImage(data){
        this.imageObj = data
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;}
  .content{background-color: #ffffff;padding:20px;border-radius: 12px;}
  .content h1{line-height: 3;color:#333333;}
  .btn{display: flex;justify-content: flex-end;margin-top:30px;}
  .img{width: 180px;height:200px;background-repeat: no-repeat;background-size: cover;background-position: center;}
  .img img{width: 180px;height:200px;object-fit: cover;}
  @media (max-width: 768px) {

  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
